import * as swcHelpers from '@swc/helpers';
import { DataLayer } from '@grandvisionhq/analytics';
import { mapProductListingToDataLayerProductObject } from '../Mappers/ProductListingMapper.js';

const createImpressionEvent = (currency)=>{
    return {
        event: 'gvProductImpressions',
        atfEcommerce: {
            ecommerce: {
                currencyCode: currency,
                impressions: []
            }
        }
    };
};
const createImpressionObject = (product, position)=>swcHelpers.objectSpread({}, mapProductListingToDataLayerProductObject(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, product.masterVariant.sku || 'undefined'), {
        list: `category: ${product.productType}`,
        position
    })
;
const createInteractionEvent = (product, position, location, currency)=>{
    return {
        event: 'gvProductClick',
        atfEcommerce: {
            ecommerce: {
                currencyCode: currency,
                click: {
                    actionField: {
                        list: location
                    },
                    products: [
                        swcHelpers.objectSpread({}, mapProductListingToDataLayerProductObject(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, product.masterVariant.sku || 'undefined'), {
                            position
                        }), 
                    ]
                }
            }
        }
    };
};

export { createImpressionEvent, createImpressionObject, createInteractionEvent };
//# sourceMappingURL=ProductListingPageEvents.js.map
